/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createInviteCodes'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  codeCount: /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer(), 1),
  useCount: /*#__PURE__*/ l.integer(),
  forAccounts: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  codes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<AccountCodes>((() => accountCodes) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create invite codes. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type AccountCodes = {
  $type?: 'com.atproto.server.createInviteCodes#accountCodes'
  account: string
  codes: string[]
}

export type { AccountCodes }

const accountCodes = /*#__PURE__*/ l.typedObject<AccountCodes>(
  $nsid,
  'accountCodes',
  /*#__PURE__*/ l.object({
    account: /*#__PURE__*/ l.string(),
    codes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  }),
)

export { accountCodes }
